import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { H4} from "../../../../AbstractElements";
import { useTranslation } from "react-i18next";

const UserOrganizationInfo = ({ data }: any) => {
    const {t}=useTranslation()
 
  return (
    <Col md={6}>
      <Card>
        <CardBody>
          <>
            <td>
              <Table responsive style={{ width: "100%" }} borderless>
                <tbody>
                  <tr
                    style={{
                      padding: "28px 0",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <td>
                      <H4>{t("OrganizationName")}</H4>
                      <H4
                        style={{
                          fontWeight: 600,
                          margin: "12px 0 5px 0",
                          fontSize: 18,
                          color: "#5C61F2",
                        }}
                      >
                        {data?.organizationname}
                      </H4>
                    </td>
                  </tr>
                  <tr
                    style={{
                      padding: "28px 0",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <td>
                      <H4>{t("Language")}</H4>
                      <span
                        style={{
                          margin: "12px 0 5px 0",
                        }}
                      >
                        {data?.languages?data?.languages.join(", "):""}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </td>
          </>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UserOrganizationInfo;
